(() => {
  'use strict';

  if (window.__wamaStickyAtcInteractionsLoaded) return;
  window.__wamaStickyAtcInteractionsLoaded = true;

  const stickyRootSelector = '.sticky-atc';
  const selectorRootSelector = '.sticky-atc--selector';
  const optionsSelector = '.sticky-atc--selector-options';
  const openClass = 'sticky-atc--selector-options__show';

  function getMainAddToCartButton() {
    const selectors = [
      '.product-form__item--submit button[data-add-to-cart]',
      '.product-form__item--submit button.product-form__cart-submit',
      'product-form form button[name="add"]'
    ];

    for (const selector of selectors) {
      const button = Array.from(document.querySelectorAll(selector)).find(
        (candidate) =>
          !candidate.closest(stickyRootSelector) &&
          candidate.offsetParent !== null
      );

      if (button) return button;
    }

    return null;
  }

  function getOptionsContainer(selectorRoot) {
    if (!selectorRoot) return null;

    const trigger = selectorRoot.querySelector('.sticky-atc--selector-label');
    const controlledId = trigger?.getAttribute('aria-controls');

    return (
      (controlledId && document.getElementById(controlledId)) ||
      selectorRoot.querySelector(optionsSelector)
    );
  }

  function closeSelector(selectorRoot, returnFocus = false) {
    if (!selectorRoot) return;

    const trigger = selectorRoot.querySelector('.sticky-atc--selector-label');
    const options = getOptionsContainer(selectorRoot);

    if (options) {
      options.hidden = true;
      options.classList.remove(openClass);
    }

    trigger?.setAttribute('aria-expanded', 'false');

    if (returnFocus) trigger?.focus();
  }

  function closeAllSelectors(exceptRoot = null) {
    document.querySelectorAll(selectorRootSelector).forEach((selectorRoot) => {
      if (selectorRoot !== exceptRoot) closeSelector(selectorRoot);
    });
  }

  function openSelector(selectorRoot) {
    if (!selectorRoot) return;

    const trigger = selectorRoot.querySelector('.sticky-atc--selector-label');
    const options = getOptionsContainer(selectorRoot);

    if (!trigger || !options) return;

    closeAllSelectors(selectorRoot);
    options.hidden = false;
    options.classList.add(openClass);
    trigger.setAttribute('aria-expanded', 'true');
  }

  function escapeCssValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/(["\\])/g, '\\$1');
  }

  function selectOption(option) {
    if (
      !option ||
      option.hidden ||
      option.disabled ||
      option.classList.contains('hidden') ||
      option.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    const selectorRoot = option.closest(selectorRootSelector);
    if (!selectorRoot) return;

    selectorRoot
      .querySelectorAll('.sticky-atc--selector-option')
      .forEach((candidate) => {
        candidate.setAttribute('aria-selected', 'false');
        candidate.setAttribute('data-checked', 'false');
      });

    option.setAttribute('aria-selected', 'true');
    option.setAttribute('data-checked', 'true');

    const currentValue = selectorRoot.querySelector(
      '.sticky-atc--selector-current'
    );

    if (currentValue) currentValue.innerHTML = option.innerHTML;

    const targetSwatchId = option.dataset.targetSwatch;

    if (targetSwatchId) {
      const targetLabel = document.querySelector(
        `label[for="${escapeCssValue(targetSwatchId)}"]`
      );
      const targetInput = document.getElementById(targetSwatchId);

      if (targetLabel) {
        targetLabel.click();
      } else if (targetInput) {
        targetInput.click();
      }
    }

    closeSelector(selectorRoot, true);
  }

  document.addEventListener(
    'click',
    (event) => {
      const stickyRoot = event.target.closest(stickyRootSelector);
      if (!stickyRoot) return;

      const stickySubmit = event.target.closest(
        '.sticky-atc--button button[data-add-to-cart], .sticky-atc--button .atcButton'
      );

      if (stickySubmit) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const mainButton = getMainAddToCartButton();
        const isDisabled =
          !mainButton ||
          mainButton.disabled ||
          mainButton.getAttribute('aria-disabled') === 'true';

        if (!isDisabled) mainButton.click();
        return;
      }

      const option = event.target.closest('.sticky-atc--selector-option');

      if (option) {
        event.preventDefault();
        event.stopImmediatePropagation();
        selectOption(option);
        return;
      }

      const trigger = event.target.closest('.sticky-atc--selector-label');

      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const selectorRoot = trigger.closest(selectorRootSelector);
        const options = getOptionsContainer(selectorRoot);
        const isOpen =
          trigger.getAttribute('aria-expanded') === 'true' ||
          (options && !options.hidden);

        if (isOpen) {
          closeSelector(selectorRoot);
        } else {
          openSelector(selectorRoot);
        }
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!event.target.closest(selectorRootSelector)) closeAllSelectors();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const selectorRoot = event.target.closest(selectorRootSelector);
    if (!selectorRoot) return;

    event.preventDefault();
    closeSelector(selectorRoot, true);
  });
})();
